import { Heart, Share2 } from 'lucide-react';
import { formatCurrency } from '../../../../../../utils/FormatCurrency';
import { useImageCarousel } from '../../../../../../hooks/useImageCarousel';
import { Link } from 'react-router-dom';
import { RegularText } from '../../../../../../utils/typography/BaseText';

export const StaySmallSmallPropertyCard = ({ property }) => {
  const images = property?.images || [];
  const { currentImageIndex, setCurrentImageIndex } = useImageCarousel(images);
  const currentImage = images[currentImageIndex];
  return (
    <Link
      to={`/real-estate/shortlet/${property?.propertyID}/${property?.propertyTitle
        .toLowerCase()
        .replace(/\s+/g, '-')}`}
    >
      <article className=" md:w-[276px] grid gap-2 border border-[#DFE0E4] rounded-[10px]">
        <div
          className="h-[218px] md:w-[276px] bg-cover bg-center rounded-t-[10px] relative transition-all duration-500"
          style={{ backgroundImage: `url(${currentImage})` }}
        >
          <div className="flex flex-col justify-between w-full h-full px-3 py-3 rounded-[10px]">
            <div className="flex items-center gap-2">
              <button>
                <span className="sr-only">Add this property to favourite</span>

                <Heart size={18} color="white" />
              </button>
              <button className="rounded-full bg-white p-1">
                <span className="sr-only">Share this property</span>
                <Share2 size={13} fill="black" />
              </button>
            </div>

            <div className="flex items-center justify-end">
              <div className="flex gap-1 pr-2">
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`h-2 w-2 rounded-full transition-all duration-300 ${
                      index === currentImageIndex
                        ? 'bg-white scale-125'
                        : 'bg-white/50'
                    }`}
                  >
                    <span className="sr-only">
                      Currently showing properly in ${currentImageIndex} slide
                    </span>
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="px-4 font-duplet font-normal flex flex-col justify-start md:items-start mt-2">
          <RegularText>
            {' '}
            {property.propertyTitle.length > 27
              ? property.propertyTitle.slice(0, 27) + '…'
              : property.propertyTitle}
          </RegularText>
          <div className="flex gap-2 flex-wrap">
            <InfoIcon
              src="/images/marker-pin-01.svg"
              text={property?.address}
            />
          </div>
        </div>

        <div className="flex flex-col items-start px-4 pb-4">
          <p className="font-semibold font-duplet">
            {formatCurrency(property?.formatted_price)}{' '}
            <span className="text-sm font-normal">/night</span>
          </p>
        </div>
      </article>
    </Link>
  );
};

const InfoIcon = ({ src, text }) => (
  <div className="flex gap-[2px] items-center">
    <img src={src} alt={text} />
    <RegularText>{text}</RegularText>
  </div>
);
